import { AnchorButton as FluentAnchorButton } from "@fluentui/web-components";
/**
 * AnchorButton
 * @summary An Anchor Custom HTML Element that functions as a button with customizable appearance, shape, and size, and can be used as a link.
 *
 * @example
 * ```html
 * <fabric-anchor-button appearance="primary" shape="rounded" size="large" href="https://example.com" target="_blank">
 *   <span slot="start">🔗</span>
 *   Visit our page
 *   <span slot="end">→</span>
 * </fabric-anchor-button>
 * ```
 *
 * @attr {AnchorButtonAppearance} appearance - The visual appearance of the button.
 * @attr {AnchorButtonShape} shape - The shape of the button, can be square, circular, or rounded.
 * @attr {AnchorButtonSize} size - The size of the button, can be small, medium, or large.
 * @attr {boolean} icon-only - Indicates the button has an icon only, no text content.
 * @attr {string} href - The URL that the hyperlink points to.
 * @attr {AnchorTarget} target - Specifies where to open the linked document.
 *
 * @prop {boolean} iconOnly - Indicates whether the button has an icon only, with no text content.
 *
 * @slot start - Content before the button content.
 * @slot - The default slot for button text or content.
 * @slot end - Content after the button content.
 *
 * @csspart content - The button content container.
 *
 * @fires click - Fired when the button is clicked.
 *
 * @extends FluentAnchorButton
 * @tagname fabric-anchor-button
 * @public
 */
export class AnchorButton extends FluentAnchorButton {
}
//# sourceMappingURL=anchor-button.js.map